import { Empty, Table, TableProps } from 'antd';
import { useEffect, useState } from 'react';

import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NotificationService from 'core/services/notification';
import { onGetWalletTransactions } from 'modules/users/services/users';
import { WalletTransaction } from 'modules/users/models/wallet-transactions';
import { useTranslation } from 'react-i18next';
import NoData from 'components/noData/noData';

interface InputProps {
	id: number;
}

function WalletTransactionsComponent({ id }: InputProps) {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [walletTransactions, setWalletTransactions] = useState<WalletTransaction[]>([]);

	useEffect(() => {
		getWalletTransactions();
	}, []);

	const columns: TableProps<WalletTransaction>['columns'] = [
		{
			title: '#',
			dataIndex: '#',
			key: '#',
			render: (id, transaction, index) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{index + 1}</span>,
		},
		{
			title: t('USERS.TYPE'),
			dataIndex: 'type',
			key: 'type',
			render: (type) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{type}</span>,
		},
		{
			title: t('USERS.DESCRIPTION'),
			dataIndex: 'description',
			key: 'description',
			render: (description) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{description}</span>,
		},
		{
			title: t('USERS.DATE'),
			dataIndex: 'date',
			key: 'date',
			render: (date) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{date}</span>,
		},
		{
			title: t('USERS.AMOUNT'),
			dataIndex: 'amount',
			key: 'amount',
			render: (amount) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{amount}</span>,
		},
	];

	const getWalletTransactions = async () => {
		try {
			setIsLoading(true);

			const response = await onGetWalletTransactions(id);
			setWalletTransactions(
				response.data.data.user_wallet_transactions.map((el, i) => {
					return { ...el, id: i };
				}),
			);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.OPS'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<>
			{isLoading ? (
				<LoadingComponent />
			) : (
				<Table rowKey="id" columns={columns} dataSource={walletTransactions} scroll={{ x: 400 }} locale={{ emptyText: <NoData /> }} />
			)}
		</>
	);
}

export default WalletTransactionsComponent;
